import { motion } from "framer-motion";
import { Check } from "lucide-react";

const IMG =
  "https://static.prod-images.emergentagent.com/jobs/f50419a1-4d39-4928-8401-7b3561821359/images/d78f5f798f4c38d492aa5eab7f02245e764de670a2ba816e79bfd025f9c90b04.png";

const POINTS = [
  "Consumer-obsessed product development",
  "Quality built for a lifetime of everyday use",
  "Global manufacturing & distribution reach",
  "Brands trusted in millions of homes",
];

export const About = () => {
  return (
    <section id="about" data-testid="about-section" className="bg-brand-bg py-24 border-t border-brand-border">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 grid lg:grid-cols-2 gap-16 items-center">
        <motion.div
          initial={{ opacity: 0, x: -24 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="relative"
        >
          <div className="overflow-hidden rounded-3xl border border-brand-border">
            <img src={IMG} alt="Organized modern home" className="w-full object-cover" />
          </div>
          <div className="absolute -bottom-6 -right-4 hidden sm:block rounded-2xl border border-[#8DC63F]/30 bg-[#13355E] px-7 py-5">
            <div className="font-heading text-3xl font-bold text-[#8DC63F]">As Seen on TV</div>
            <div className="text-xs uppercase tracking-[0.15em] text-slate-300">
              Direct-response pioneers
            </div>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: 24 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <span className="text-sm uppercase tracking-[0.25em] text-[#8DC63F]">About Us</span>
          <h2 className="mt-4 font-heading text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-brand-text">
            Enriching life through innovation
          </h2>
          <p className="mt-6 text-base leading-relaxed text-brand-muted">
            Hampton Direct is a leader in the direct-response industry, marketing some
            of the most successful consumer products in “As Seen on TV” history. We
            develop, brand and market innovative products that solve specific household
            problems — turning everyday frustrations into simple, satisfying solutions.
          </p>
          <p className="mt-4 text-base leading-relaxed text-brand-muted">
            From PajamaJeans to the Wonder Hanger, our brands have become household
            names because we start with one question: how do we make life better?
          </p>

          <ul className="mt-8 grid sm:grid-cols-2 gap-4">
            {POINTS.map((p) => (
              <li key={p} className="flex items-start gap-3">
                <span className="mt-0.5 grid h-6 w-6 shrink-0 place-items-center rounded-full bg-[#8DC63F]/15 text-[#8DC63F]">
                  <Check size={14} />
                </span>
                <span className="text-sm text-brand-muted">{p}</span>
              </li>
            ))}
          </ul>
        </motion.div>
      </div>
    </section>
  );
};
